<div class="pb-2 mb-3">
  <h3>
    <b>Points of presence - trigram reference</b>
  </h3>
</div>
<ul class="nav nav-tabs" id="myTab" role="tablist">
  <li *roles="['ROLE_MCKAY']" class="nav-item">
    <a (click)="changeSelectedTab('Pop list')" [ngClass]="{active: selectedTab === 'Pop list'}" aria-controls="pops"
       [attr.aria-selected]="selectedTab === 'Pop list'"
       class="nav-link" data-toggle="tab" id="pops-tab" role="tab">
      <i class="fa fa-fw fa-list"></i>Pops
    </a>
  </li>
  <li *roles="['ROLE_MCKAY']" class="nav-item">
    <a (click)="changeSelectedTab('bw-map')" [ngClass]="{active: selectedTab === 'bw-map'}" aria-controls="map"
       [attr.aria-selected]="selectedTab === 'bw-map'"
       class="nav-link" data-toggle="tab" id="bw-map" role="tab">
      <i class="fa fa-fw fa-map-marker"></i>Bandwidth service map
    </a>
  </li>
  <li *roles="['ROLE_MCKAY']" class="nav-item">
    <a (click)="changeSelectedTab('md-map')" [ngClass]="{active: selectedTab === 'md-map'}" aria-controls="map"
       [attr.aria-selected]="selectedTab === 'md-map'"
       class="nav-link" data-toggle="tab" id="md-map" role="tab">
      <i class="fa fa-fw fa-map-marker"></i>Market data service map
    </a>
  </li>
  <li *roles="['ROLE_MCKAY']" class="nav-item">
    <a (click)="changeSelectedTab('BW')" [ngClass]="{active: selectedTab === 'BW'}" aria-controls="bw"
       [attr.aria-selected]="selectedTab === 'BW'"
       class="nav-link" data-toggle="tab" id="bw-availability-tab" role="tab">
      Available Bandwith services
    </a>
  </li>
  <li *roles="['ROLE_MCKAY']" class="nav-item">
    <a (click)="changeSelectedTab('MD')" [ngClass]="{active: selectedTab === 'MD'}" aria-controls="md"
       [attr.aria-selected]="selectedTab === 'MD'"
       class="nav-link" data-toggle="tab" id="md-availability-tab" role="tab">
      Available Market data services
    </a>
  </li>
</ul>
<br *roles="['ROLE_MCKAY']">
<br>
<div *ngIf="loadError && selectedTab !== 'BW' && selectedTab !== 'MD'" class="alert alert-danger" role="alert">
  Unable to load commercial POPs right now. Please try again later.
</div>
<div *ngIf="selectedTab === 'Pop list'">
  <div class="row">
    <div class="col-12">
      <p-panel [toggleable]="true">
        <ng-template pTemplate="header">
          <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
        </ng-template>
        <div class="row">
          <div class="form-group col-3">
            <div class="row">
              <label class="control-label col-4">Name</label>
              <div class="col-8">
                <input [(ngModel)]="popTrigramFilterCriteria.name" (ngModelChange)="filterTable()" class="form-control"
                       name="name" type="text">
              </div>
            </div>
          </div>
          <div class="form-group col-3">
            <div class="row">
              <label class="control-label col-4">Continent</label>
              <div class="col-8">
                <input [(ngModel)]="popTrigramFilterCriteria.continent" (ngModelChange)="filterTable()"
                       class="form-control"
                       name="continent" type="text">
              </div>
            </div>
          </div>
          <div class="form-group col-3">
            <div class="row">
              <label class="control-label col-4">Commercial POP</label>
              <div class="col-8">
                <input [(ngModel)]="popTrigramFilterCriteria.displayId" (ngModelChange)="filterTable()"
                       class="form-control"
                       name="displayId" type="text">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <div class="row">
              <label class="control-label col-2">Service</label>
              <div class="col-10" style="display: inherit;padding-top: 5px;">
                <div class="margin-checkbox">
                  <p-checkbox [(ngModel)]="popTrigramFilterCriteria.bwService" (ngModelChange)="filterTable()"
                              binary="true"
                              label="Bandwidth"
                              name="bwService" value="true"></p-checkbox>
                </div>
                <div class="margin-checkbox">
                  <p-checkbox [(ngModel)]="popTrigramFilterCriteria.qedService" (ngModelChange)="filterTable()"
                              binary="true"
                              label="QED"
                              name="qed" value="true"></p-checkbox>
                </div>
                <div class="margin-checkbox">
                  <p-checkbox [(ngModel)]="popTrigramFilterCriteria.qrdService" (ngModelChange)="filterTable()"
                              binary="true"
                              label="QRD"
                              name="qrd" value="true"></p-checkbox>
                </div>
                <div class="margin-checkbox">
                  <p-checkbox [(ngModel)]="popTrigramFilterCriteria.qfdService" (ngModelChange)="filterTable()"
                              binary="true"
                              label="QFD"
                              name="qfd" value="true"></p-checkbox>
                </div>
                <div class="margin-checkbox">
                  <p-checkbox [(ngModel)]="popTrigramFilterCriteria.qhfService" (ngModelChange)="filterTable()"
                              binary="true"
                              label="QHF"
                              name="qhf" value="true"></p-checkbox>
                </div>
                <div class="margin-checkbox">
                  <p-checkbox [(ngModel)]="popTrigramFilterCriteria.newsService" (ngModelChange)="filterTable()"
                              binary="true"
                              label="News"
                              name="news" value="true"></p-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
  <p-table #dt (sortFunction)="groupedSort($event)" [columns]="cols" [customSort]="true"
           [paginator]="false" [rows]="50"
           [tableStyle]="{'table-layout':'auto'}" [value]="this.commercialPopFilteredList"
           exportFilename="Commercial POPs" id="history_navigation_table">
    <ng-template pTemplate="caption">
      <div class="p-helper-clearfix caption-buttons-container" style="text-align: left">
        <button (click)="exportCsv()" icon="pi pi-file-o" iconPos="left" label="Download" pButton
                style="margin-right: 0.5em;"
                type="button"></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" [pSortableColumnDisabled]="!col.sortable" [pSortableColumn]="col.field" class="header-nowrap">
          {{ col.header }}
          <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template let-pop let-rowIndex="rowIndex" pTemplate="body">
      <tr>
        <td>{{ pop.commercialPop }}</td>
        <td>
          <ng-container *ngFor="let tPop of pop.technicalPop; let isLast=last">
            <span *ngIf="tPop.isArchived" style="text-decoration: line-through">
              <span [pTooltip]="technicalPopService.getCageTooltip(tPop.technicalId)">{{ tPop.technicalId }} </span>
            </span>
            <span *ngIf="!tPop.isArchived">
              <span [pTooltip]="technicalPopService.getCageTooltip(tPop.technicalId)">{{ tPop.technicalId }} </span>
            </span>{{ isLast ? '' : ', ' }}
          </ng-container>
        </td>
        <td>
          <a *ngIf="!getIsMckayUser()">
            <i *ngIf="pop.bwService" aria-hidden="true" class="fa fa-check information-btn" style="pointer-events: none"></i>
          </a>
          <a *ngIf="getIsMckayUser()">
            <i (click)="displayBwPopUp($event, opBw, pop.displayId)" (close)="opBw.hide()" *ngIf="pop.bwService"
               aria-hidden="true" class="fa fa-check information-btn"></i>
          </a>
          <p-overlayPanel #opBw [dismissable]="true" [style]="{width: '15%'}" appendTo="body">
            <div>
              <h6 style="text-align: center"> BW Service available</h6>
              <hr>
              <p *ngFor="let pop of bwServiceTechnicalPops">
                {{ pop }}
              </p>
            </div>
          </p-overlayPanel>
        </td>
        <td style="min-width: 102px;">
          <a *ngIf="!getIsMckayUser()">
            <i *ngIf="pop.qedService" aria-hidden="true" class="fa fa-check information-btn" style="pointer-events: none"></i>
          </a>
          <a *ngIf="getIsMckayUser()">
            <i (click)="displayMdPopUp($event, opQed, pop.displayId, 'qed')" (close)="opQed.hide()"
               *ngIf="pop.qedService"
               aria-hidden="true" class="fa fa-check information-btn"></i>
          </a>
          <p-overlayPanel #opQed [dismissable]="true" [style]="{width: '15%'}" appendTo="body">
            <div>
              <h6 style="text-align: center"> QED Service available</h6>
              <hr>
              <p *ngFor="let pop of mdServiceTechnicalPops">
                {{ pop }}
              </p>
            </div>
          </p-overlayPanel>
        </td>
        <td style="min-width: 102px;">
          <a *ngIf="!getIsMckayUser()">
            <i *ngIf="pop.qrdService" aria-hidden="true" class="fa fa-check information-btn" style="pointer-events: none"></i>
          </a>
          <a *ngIf="getIsMckayUser()">
            <i (click)="displayMdPopUp($event, opQrd, pop.displayId, 'qrd')" (close)="opQrd.hide()"
               *ngIf="pop.qrdService"
               aria-hidden="true" class="fa fa-check information-btn"></i>
          </a>
          <p-overlayPanel #opQrd [dismissable]="true" [style]="{width: '15%'}" appendTo="body">
            <div>
              <h6 style="text-align: center"> QRD Service available</h6>
              <hr>
              <p *ngFor="let pop of mdServiceTechnicalPops">
                {{ pop }}
              </p>
            </div>
          </p-overlayPanel>
        </td>
        <td style="min-width: 102px;">
          <a *ngIf="!getIsMckayUser()">
            <i *ngIf="pop.qfdService" aria-hidden="true" class="fa fa-check information-btn" style="pointer-events: none"></i>
          </a>
          <a *ngIf="getIsMckayUser()">
            <i (click)="displayMdPopUp($event, opQfd, pop.displayId, 'qfd')" (close)="opQfd.hide()"
               *ngIf="pop.qfdService"
               aria-hidden="true" class="fa fa-check information-btn"></i>
          </a>
          <p-overlayPanel #opQfd [dismissable]="true" [style]="{width: '15%'}" appendTo="body">
            <div>
              <h6 style="text-align: center"> QFD Service available</h6>
              <hr>
              <p *ngFor="let pop of mdServiceTechnicalPops">
                {{ pop }}
              </p>
            </div>
          </p-overlayPanel>
        </td>
        <td style="min-width: 102px;">
          <a *ngIf="!getIsMckayUser()">
            <i *ngIf="pop.qhfService" aria-hidden="true" class="fa fa-check information-btn" style="pointer-events: none"></i>
          </a>
          <a *ngIf="getIsMckayUser()">
            <i (click)="displayMdPopUp($event, opQhf, pop.displayId, 'qhf')" (close)="opQhf.hide()"
               *ngIf="pop.qhfService"
               aria-hidden="true" class="fa fa-check information-btn"></i>
          </a>
          <p-overlayPanel #opQhf [dismissable]="true" [style]="{width: '15%'}" appendTo="body">
            <div>
              <h6 style="text-align: center"> QHF Service available</h6>
              <hr>
              <p *ngFor="let pop of mdServiceTechnicalPops">
                {{ pop }}
              </p>
            </div>
          </p-overlayPanel>
        </td>
        <td style="min-width: 102px;">
          <a *ngIf="!getIsMckayUser()">
            <i *ngIf="pop.newsService" aria-hidden="true" class="fa fa-check information-btn" style="pointer-events: none"></i>
          </a>
          <a *ngIf="getIsMckayUser()">
            <i (click)="displayMdPopUp($event, opnews, pop.displayId, 'news')" (close)="opnews.hide()"
               *ngIf="pop.newsService"
               aria-hidden="true" class="fa fa-check information-btn"></i>
          </a>
          <p-overlayPanel #opnews [dismissable]="true" [style]="{width: '15%'}" appendTo="body">
            <div>
              <h6 style="text-align: center"> Quincy News Service available</h6>
              <hr>
              <p *ngFor="let pop of mdServiceTechnicalPops">
                {{ pop }}
              </p>
            </div>
          </p-overlayPanel>
        </td>
        <td>{{ pop.address }}</td>
        <td *ngIf="rowGroupMetadata[pop.continent]?.index === rowIndex"
            [attr.rowspan]="rowGroupMetadata[pop.continent].size" class="continent" style="text-align: center;">
          {{ pop.continent }}
        </td>
        <td *ngIf="!rowGroupMetadata[pop.continent]?.index && rowGroupMetadata[pop.continent]?.index !== 0">
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      {{ commercialPopFilteredList?.length }} POPs
    </ng-template>
  </p-table>
  <br>
  <br>
  <hr>
</div>
<ng-container *roles="['ROLE_MCKAY']">
  <div *ngIf="selectedTab === 'bw-map'">
    <app-bw-service-map [commercialPopList]="commercialPopList"></app-bw-service-map>
  </div>
</ng-container>

<ng-container *roles="['ROLE_MCKAY']">
  <div *ngIf="selectedTab === 'md-map'">
    <apcol-md-service-map [commercialPopList]="commercialPopList"></apcol-md-service-map>
  </div>
</ng-container>

<ng-container *roles="['ROLE_MCKAY']">
  <div *ngIf="selectedTab === 'MD'">
    <apcol-md-availability></apcol-md-availability>
  </div>
</ng-container>

<ng-container *roles="['ROLE_MCKAY']">
  <div *ngIf="selectedTab === 'BW'">
    <app-bw-availability></app-bw-availability>
  </div>
</ng-container>
